import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// SystemUsers Redux States
import {
  GET_SYSTEM_USERS,
  GET_SYSTEM_USER,
  CREATE_SYSTEM_USER,
  EDIT_SYSTEM_USER,
  ACTIVATE_SYSTEM_USER,
} from "./actionTypes";
import {
  setSystemUsers,
  apiError,
  setSystemUser,
  createSystemUserSuccess,
  editSystemUserSuccess,
  activateSystemUserSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getSystemUsers({ payload: { page, qnt, name, email, nickname } }) {
  try {
    const response = yield call(
      axios.get,
      `/system-user?${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (nickname ? `&nickname=${nickname}` : "") +
        (email ? `&email=${email}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setSystemUsers(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createSystemUser({ payload: { newSystemUserValues } }) {
  try {
    const response = yield call(axios.post, "/system-user", newSystemUserValues);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(createSystemUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getSystemUser({ payload: { idSystemUser, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/system-user?${
        (idSystemUser ? `&id=${idSystemUser}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setSystemUser(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editSystemUser({ payload: { idSystemUser, newSystemUserValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/system-user?${idSystemUser ? `&id=${idSystemUser}` : ""}`,
      newSystemUserValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editSystemUserSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* activateSystemUser({ payload: { idSystemUser, active } }) {
  try {
    const response = yield call(
      axios.patch,
      `/system-user/activate?${idSystemUser ? `&id=${idSystemUser}` : ""}`,
      active
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(activateSystemUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchSystemUser() {
  yield takeEvery(GET_SYSTEM_USERS, getSystemUsers);
}
export function* watchCreateSystemUser() {
  yield takeEvery(CREATE_SYSTEM_USER, createSystemUser);
}
export function* watchGetSystemUser() {
  yield takeEvery(GET_SYSTEM_USER, getSystemUser);
}
export function* watchEditSystemUser() {
  yield takeEvery(EDIT_SYSTEM_USER, editSystemUser);
}
export function* watchActivateSystemUser() {
  yield takeEvery(ACTIVATE_SYSTEM_USER, activateSystemUser);
}
function* authSaga() {
  yield all([
    fork(watchSystemUser),
    fork(watchGetSystemUser),
    fork(watchCreateSystemUser),
    fork(watchEditSystemUser),
    fork(watchActivateSystemUser),
  ]);
}

export default authSaga;
